/**
 * Validation utilities for Estimation funnel
 */

export const validateStep = (step, formData) => {
  const newErrors = {};

  if (step === 1) {
    if (!formData.property_type) newErrors.property_type = 'Requis';
    if (!formData.city) newErrors.city = 'Requis';
    if (!formData.bedrooms) newErrors.bedrooms = 'Requis';
  }

  if (step === 2) {
    if (!formData.capacity) newErrors.capacity = 'Requis';
  }

  if (step === 3) {
    if (!formData.address) newErrors.address = 'Requis';
    if (!formData.postal_code) newErrors.postal_code = 'Requis';
    if (!formData.city_full) newErrors.city_full = 'Requis';
  }

  if (step === 4) {
    if (!formData.first_name) newErrors.first_name = 'Requis';
    if (!formData.last_name) newErrors.last_name = 'Requis';
    if (!formData.email) newErrors.email = 'Requis';
    else if (!/\S+@\S+\.\S+/.test(formData.email)) newErrors.email = 'Email invalide';
    if (!formData.phone) newErrors.phone = 'Requis';
  }

  return newErrors;
};

export const buildLeadPayload = (formData) => {
  return {
    ...formData,
    bedrooms: parseInt(formData.bedrooms),
    capacity: parseInt(formData.capacity),
    name: `${formData.first_name} ${formData.last_name}`
  };
};
